export default "__VITE_ASSET__BxEqyJxL__"